<!--//jeb include the resume generator in the pw portal or naw? move route out of /dashboard somehow? -->
<create-online-resume *ngIf="!IsMatrixToolsDashboard"></create-online-resume>
<div *ngIf="IsMatrixToolsDashboard">
  <matrix-tools-service-dashboard *ngIf="user; else Login" [ClientId]="user.clientId"></matrix-tools-service-dashboard>
  <ng-template #Login>
    <login *ngIf="IsMatrixToolsDashboard"></login>
  </ng-template>
</div>

<!--
    //jeb free account sign up VS 'business' sign up forms  
<div *ngIf="IsMatrixToolsWebPortfolio">
  <sign-up-web-resume></sign-up-web-resume>
</div>
<div *ngIf="IsMatrixToolsDashboard">
  <sign-up-portal></sign-up-portal>
</div> -->
